import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getPopularDetailContent } from '../../../../../redux/actions/reports'
import { IRootState } from '../../../../../redux/types'

export default function usePopularDetailContent() {
  const dispatch = useDispatch()
  const { popularDetailContent, menuCodes } = useSelector((state: IRootState) => state.report)

  useEffect(() => {
    dispatch(getPopularDetailContent())
  }, [])

  return { menuCodes: menuCodes, reports: popularDetailContent }
}
